function initSearch() {

  const searchInputs = $('.sh-home-search-input');

  searchInputs.change(function () {
    const searchWrap = $(this).closest('.sh-home-search');
    if ($(this).val().length === 0) {
      $(this).autocomplete.previous = null;
      searchWrap.find('.sh-clear-search').hide();
    } else if (searchWrap.find('.spinner').is(':hidden')) {
      searchWrap.find('.sh-clear-search').show();
    }
  });

  searchInputs.each(function (i, el) {
    const searchInput = $(el);
    const searchParent = searchInput.parent().parent();

    searchInput.autocomplete({
      delay: 300,
      deferRequestBy: 300,
      appendTo: '.search-box-results',
      lookup: function (query) {
        searchParent.find('.sh-search-actions .spinner').show();
        searchParent.find('.sh-clear-search').hide();

        $.ajax({
          url: window.ajax.url,
          type: 'get',
          dataType: 'json',
          data: {
            action: 'search_products_and_vendors',
            q: query,
          },
          success: function (result) {
            searchParent.find('.sh-search-actions .spinner').hide();
            if (query.length === 0) {
              searchParent.find('.sh-clear-search').hide();
            } else {
              searchParent.find('.sh-clear-search').show();
            }

            let htmlSuggestions = '';

            result.data.forEach(function (element) {
              const result = highlightText(element.name, query);
              const resultType = element.type.charAt(0).toUpperCase() + element.type.slice(1);
              htmlSuggestions += `<li><a href="${element.url}">${result}</a><span class="sh-type-${element.type}">${resultType}</span></li>`;
            });

            if (result.data.length) {
              searchParent.find('.sh-search-suggestions').show();
              searchParent.find('.sh-search-suggestions').html(`<ul>${htmlSuggestions}</ul>`);
            } else {
              searchParent.find('.sh-search-suggestions').show();
              searchParent.find('.sh-search-suggestions').html(`<p class="sh-no-results">No results found for <b>${query}</b></p>`);
            }

          },
          error() {
            searchParent.find('.sh-search-actions .spinner').hide();
          },
        });
      },
      onSelect(suggestion) {
        window.location.href = suggestion.data.url;
      },
    });
  });

  $('.sh-search-actions .sh-clear-search').click(function () {
    const searchInput = $(this).closest('.sh-home-search').find('.sh-home-search-input');
    searchInput.val('');
    searchInput.change();
    searchInput.autocomplete('clear');
  })


  $(document).on('click', function (event) {
    if ($(event.target).closest('.sh-home-search-input').length === 0) {
      $('.sh-search-suggestions').hide();
    }
  });
}

function highlightText(input, text) {
  const reg = new RegExp(text, 'gi');
  return input.replace(reg, function (str) {
    return '<b>' + str + '</b>'
  });
}

export default {
  init: function () {
    initSearch();
  },
  finalize() {
  },
};
